module.exports = "<app-page><div class=\"layout-column h-100\"><div *ngFor=\"let thread of threads | sortByDate:'timestamp':'asc'\"><div class=\"flex-100-nogrow\"><region-thread [thread]=\"thread\" (openThread)=\"openThread($event)\"></region-thread></div></div><div class=\"flex text-center layout-padding\" *ngIf=\"threads.length&lt;1\"><h3 class=\"title\">There is no chats open, click on the icon at right to start chatting.</h3></div></div></app-page>";


//////////////////
// WEBPACK FOOTER
// ./src/app/chat/chatindex/chat-index.component.pug
// module id = 1050
// module chunks = 0